import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { BillingServiceService } from '../billing-service.service';
import { BillingServiceService } from '../../billing/billing-service.service';
import { environment } from '../../../environments/environment';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../profile/profile.service';
import * as CryptoJS from 'crypto-js';
import { Theme } from '../../shared/service/AutoTheme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-addamount',
  templateUrl: './addamount.component.html',
  styleUrls: ['./addamount.component.css']
})
export class AddamountComponent implements OnInit {

   // form: FormGroup;
   submitted:boolean = false;
   ammount:number=0;
   isDisable:Boolean=false;
   isloader:Boolean=false;
   amount:any;
   form = new FormGroup({
     amount:new FormControl('', [Validators.required, Validators.min(1)]),
     card:new FormControl('', [Validators.required])
   });
   amountValidation: boolean=true;
   cardData:any[]=[];
   // balance:number=0;
   iscard:boolean=false;
   subimitted:Boolean=false;
   cardmessage:boolean=false;
   card_data:any[]=[];
   balance:any
   TopUpData:any
   Topup:any
   dipsAmount:any;
   topupAmount:any;
   public button_name:any='Pay now';
   secretkey:any=environment.secret_key;
 
   constructor(public dialogRef: MatDialogRef<AddamountComponent>,private fb: FormBuilder,private data:BillingServiceService,private snackBar : MatSnackBar,private NgbService: NgbModal,protected data1: ProfileService,public theme:Theme,protected router: Router) {}
 
   ngOnInit(): void {
     this.TopUpData=this.theme.TopUpData.subscribe((res:any)=>{
       this.Topup=res;
     })
     this.balance = sessionStorage.getItem('balance'); 

     this.getCard()
     // this.getBalance()
     const keyobj = this.decryptData(sessionStorage.getItem('tokenauthkey'));
     if(keyobj){
       this.getProfile(keyobj.id);
     }
 
    //  this.getAmount();
       
   }
 
   get f() { return this.form.controls; }
 
  //  makeform(data:any){
  //    this.form.patchValue({
  //      firstName:data.firstName,
  //      lastName:data.lastName,
  //      phone:data.contact,
  //      email: data.email,
  //      address1:data.address,
  //      city: data.city,
  //    })
  //  }
   nonNegativeValidator(control: AbstractControl): { [key: string]: boolean } | null {
     const value = control.value;
     if (value < 0) {
       return { nonNegative: true };
     }
     return null;
   }
   noSpaceValidator(control: AbstractControl): { [key: string]: boolean } | null {
     if (typeof control.value === 'string' && control.value.trim().length === 0) {
       return { noSpace: true };
     }
     return null;
   }
 
   stripe:any
   elements:any;
   paymentElement:any
 
   onSubmit() {
     console.log("comming here ::",this.iscard);
     if(this.form.invalid || !this.amountValidation){
         this.subimitted=true;
     }else{
       this.isloader=true;
       console.log("form value ::",this.form.value);
      //  add amount function call
        this.ADDbalance(this.form.value.amount);
     }
   }
   
   ADDbalance(amount:any){
     this.data.addBalance({data:this.card_data,amount:amount,currentbalance:this.balance}).subscribe((res:any)=>{
       console.log("getting responce ::: balance",res);
       if (!res.error) {
        if(res.amount>0){
          this.isloader=false;
          let netamount = parseInt(sessionStorage.getItem('balance')) + parseInt(res.amount);
          sessionStorage.setItem('balance', netamount.toString());
          this.balance=sessionStorage.getItem('balance');
          this.theme.__balance.next(this.balance);
          this.form.reset();
          this.openSnackBar(res.message,'clear');
          this.router.navigate(['/main/dashboards/dashboard3']) 
          this.dialogRef.close();
        }else{
            this.isloader=false;
            this.form.reset();
            this.openSnackBar(res.message,'clear');
            this.dialogRef.close();
        }
       }
       }, err => {
         console.error("err::", err)
       })
   }
 
   onselectCard(event:any,data:any,ind:number){
     if(event.target.checked==true){
       this.iscard=true;
       this.card_data=data;
       console.log("getting data :::", this.card_data);
     }
   }

   getCard(){
     this.data1.getService('cards').subscribe((res:any)=>{
       console.log("card data ::",res);
       this.cardData=res;
       this.card_data = res.find((element) => element.isdefault === 1);
       console.log("getting default cards",this.card_data);
      this.patchcard( this.card_data);
     })
   }
   patchcard(data:any){
    this.form.patchValue({
      card:data.id
     })
   }
   // getBalance(){
   //   this.data1.getService('balance').subscribe((res:any)=>{
   //     this.balance=res[0].balance;
   //     console.log("balance :::=>",this.balance);
   //   })
   // }
   OnAmount(event:any){   
    if(event>'0')
      this.button_name='Pay now $'+ event;
    else
      this.button_name='Pay now';
   }
 
   getammount(e:any){
     this.ammount=e.target.value;
     let x=e.target.value.toString().split('.')[1]
     console.log(typeof x)
     if(x){
       if(x.length>2){
         this.amountValidation=false
         console.log(this.amountValidation)
       }else{
         this.amountValidation=true
       }
     } 
   }
   
   openSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
       duration: 5000
       , verticalPosition: 'top',
       horizontalPosition: 'center',
       panelClass: ['snackbarwarn']
     });
   }
 
   
   getProfile(key:any){
     this.data1.detailService(key).subscribe(res => {
       console.log("res:: profile @@###", res);
       [res[0].firstName, res[0].lastName] = res[0].fullname.split(' ');
       console.log("res:: profile @@###", res);
      //  this.makeform(res[0])
     })
   }
 
 
   decryptData(data) {
     try {
       const bytes = CryptoJS.AES.decrypt(data, sessionStorage.getItem('token'));
       if (bytes.toString()) {
         return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
       }
       return data;
     } catch (e) {
       console.log(e);
     }
   }
   getAmount(){
     this.data1.getService('amountsetting').subscribe((res:any)=>{
       console.log("getting amount ::",res);
       if(!res.err){
         this.balance = sessionStorage.getItem('balance'); 
         this.dipsAmount=res[0].dips_amount;
         this.topupAmount=res[0].topup_amount
       }
     },err=>{
       // this.formpatch(this.dfltFormval)
       console.log("getting error");
     })
   }

   onchangecard(e:any){
    this.cardData;
    this.card_data =this.cardData.find((element) => element.id == e.target.value);
    console.log(" this.card_data", this.card_data);
   }

    closeDialog(){
      this.dialogRef.close();
    }
 }
 